/* Gohart Gifts rad van fortuin: popup met rad, e-mail + nieuwsbrief, eenmalige prijs */
(function () {
  var root = document.getElementById('gh-wheel');
  if (!root) return;
  var API = (root.dataset.api || '').replace(/\/$/, '');
  var PRIVACY = root.dataset.privacy || '/pages/privacybeleid';
  var CART_ADD = root.dataset.cartAdd || '/cart/add.js';
  var KEY = 'gh_wheel_result', DISMISS = 'gh_wheel_dismissed';
  var COLORS = ['#FF6F9E', '#FFD976', '#9FE8D8', '#B79CFF', '#FFB38A'];
  var NS = 'http://www.w3.org/2000/svg';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function svg(tag, attrs) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
  function fmtDate(iso) { return new Date(iso).toLocaleDateString('nl-BE', { day: 'numeric', month: 'long', year: 'numeric' }); }
  function saved() {
    try { var r = JSON.parse(lsGet(KEY) || 'null'); return r; } catch (e) { return null; }
  }

  fetch(API + '/api/config').then(function (r) { return r.json(); }).then(init).catch(function () {});

  function init(cfg) {
    if (!cfg.enabled) return;
    var t = cfg.texts, prizes = cfg.prizes, n = prizes.length;
    var previous = saved();
    var spun = !!previous;
    var cartChanged = false;

    /* ---------- zwevende knop ---------- */
    var fab = el('button', 'gh-fab');
    fab.type = 'button';
    function fabLabel() {
      var p = saved();
      fab.textContent = '';
      fab.appendChild(el('span', 'gh-fab__emoji', p && p.code ? '🎁' : '🎡'));
      fab.appendChild(el('span', null, p ? (p.code ? 'Jouw cadeau' : 'Bedankt!') : 'Draai & win'));
    }
    fabLabel();
    document.body.appendChild(fab);

    /* ---------- modal ---------- */
    var overlay = el('div', 'gh-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', t.title);
    var box = el('div', 'gh-box');
    var close = el('button', 'gh-close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Sluiten');
    var stamp = el('span', 'gh-stamp', 'Gohart Gifts');
    var title = el('h2', 'gh-title', t.title);
    var intro = el('p', 'gh-intro', t.intro);
    var wheelWrap = el('div', 'gh-wheelwrap');
    var panel = el('div', 'gh-panel');
    box.appendChild(close); box.appendChild(stamp); box.appendChild(title); box.appendChild(intro);
    box.appendChild(wheelWrap); box.appendChild(panel);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    /* ---------- rad tekenen ---------- */
    var seg = 360 / n;
    var s = svg('svg', { viewBox: '-104 -116 208 220', class: 'gh-wheel', 'aria-hidden': 'true' });
    var g = svg('g', { class: 'gh-wheel__rotor' });
    g.appendChild(svg('circle', { r: 100, fill: '#2B1A3D' }));
    function pt(angle, r) { var a = (angle - 90) * Math.PI / 180; return [r * Math.cos(a), r * Math.sin(a)]; }
    for (var i = 0; i < n; i++) {
      var a0 = i * seg, a1 = (i + 1) * seg, p0 = pt(a0, 95), p1 = pt(a1, 95);
      var color = COLORS[i % COLORS.length];
      if (i === n - 1 && n > 1 && color === COLORS[0]) color = COLORS[4];
      var path = svg('path', { d: 'M0 0 L' + p0[0] + ' ' + p0[1] + ' A95 95 0 ' + (seg > 180 ? 1 : 0) + ' 1 ' + p1[0] + ' ' + p1[1] + ' Z', fill: color, stroke: '#2B1A3D', 'stroke-width': 1.6 });
      g.appendChild(path);
      var label = prizes[i].label;
      var base = n <= 6 ? 11 : n <= 8 ? 9.6 : 8.4;
      var size = Math.min(base, 150 / Math.max(label.length, 1) * (n <= 6 ? 0.95 : 0.8));
      var txt = svg('text', { x: 86, y: size * 0.35, 'text-anchor': 'end', 'font-size': size, 'font-weight': 700, fill: '#2B1A3D', transform: 'rotate(' + (a0 + seg / 2 - 90) + ')', class: 'gh-wheel__label' });
      txt.textContent = label;
      g.appendChild(txt);
    }
    g.appendChild(svg('circle', { r: 11, fill: '#FFF8F0', stroke: '#2B1A3D', 'stroke-width': 2.4 }));
    s.appendChild(g);
    s.appendChild(svg('path', { d: 'M-9 -112 L9 -112 L0 -93 Z', fill: '#E85485', stroke: '#2B1A3D', 'stroke-width': 2.4, 'stroke-linejoin': 'round' }));
    wheelWrap.appendChild(s);

    /* ---------- weergave-toestanden ---------- */
    function showForm(message) {
      panel.textContent = '';
      var form = el('form', 'gh-form');
      form.noValidate = true;
      var email = el('input', 'gh-input');
      email.type = 'email'; email.name = 'email'; email.required = true; email.autocomplete = 'email';
      email.placeholder = 'Je e-mailadres';
      var consentLabel = el('label', 'gh-consent');
      var cb = el('input'); cb.type = 'checkbox';
      var span = el('span'); span.appendChild(document.createTextNode(t.consent + ' '));
      var pl = el('a', null, 'Privacybeleid'); pl.href = PRIVACY; pl.target = '_blank'; pl.rel = 'noopener';
      span.appendChild(pl);
      consentLabel.appendChild(cb); consentLabel.appendChild(span);
      var btn = el('button', 'gh-btn', t.button); btn.type = 'submit';
      var err = el('p', 'gh-error'); err.setAttribute('role', 'alert');
      if (message) err.textContent = message;
      form.appendChild(email); form.appendChild(consentLabel); form.appendChild(btn); form.appendChild(err);
      panel.appendChild(form);
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        err.textContent = '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { err.textContent = 'Vul een geldig e-mailadres in.'; email.focus(); return; }
        if (!cb.checked) { err.textContent = 'Vink het vakje aan om je in te schrijven voor de nieuwsbrief.'; return; }
        btn.disabled = true; btn.textContent = 'Even geduld…';
        fetch(API + '/api/spin', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email: email.value.trim(), consent: true }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              btn.disabled = false; btn.textContent = t.button;
              err.textContent = (res.d && res.d.message) || 'Er ging iets mis. Probeer het opnieuw.';
              return;
            }
            panel.classList.add('is-spinning');
            email.disabled = true; cb.disabled = true;
            btn.textContent = 'Het rad draait…';
            spinTo(res.d);
          })
          .catch(function () { btn.disabled = false; btn.textContent = t.button; err.textContent = 'Geen verbinding. Probeer het opnieuw.'; });
      });
    }

    function showResult(res, fromSaved) {
      panel.classList.remove('is-spinning');
      panel.textContent = '';
      var win = !!res.code;
      title.textContent = win ? (fromSaved ? 'Jouw cadeau' : 'Gefeliciteerd!') : 'Bedankt voor het meedraaien!';
      intro.textContent = win ? 'Jij won: ' + res.label : 'Deze keer geen prijs, maar je bent wel ingeschreven voor onze nieuwsbrief.';
      intro.classList.toggle('gh-intro--win', win);
      if (win) {
        var code = el('div', 'gh-code');
        var cv = el('strong', null, res.code);
        var copy = el('button', 'gh-copy', 'Kopieer'); copy.type = 'button';
        copy.addEventListener('click', function () {
          var done = function () { copy.textContent = 'Gekopieerd ✓'; setTimeout(function () { copy.textContent = 'Kopieer'; }, 2000); };
          if (navigator.clipboard) navigator.clipboard.writeText(res.code).then(done, done); else done();
        });
        code.appendChild(cv); code.appendChild(copy);
        panel.appendChild(code);
        if (res.expiresAt) panel.appendChild(el('p', 'gh-note', 'Eenmalig te gebruiken, geldig tot en met ' + fmtDate(res.expiresAt) + '.'));
        var row = el('div', 'gh-actions');
        if (res.type === 'free_product') {
          var cartNote = el('p', 'gh-note', 'Even kijken of je cadeau in je winkelmandje zit…');
          panel.appendChild(cartNote);
          var go = el('a', 'gh-btn', 'Naar mijn winkelmandje'); go.href = '/cart';
          var readd = el('button', 'gh-btn', 'Zet mijn cadeau in het mandje'); readd.type = 'button';
          readd.hidden = true; go.hidden = true;
          row.appendChild(readd); row.appendChild(go);
          var showState = function (has) {
            readd.hidden = has; go.hidden = !has;
            cartNote.textContent = has
              ? 'Je cadeau zit in je winkelmandje voor € 0,00. Haal het er niet uit, de code werkt alleen samen met dit cadeau.'
              : 'Je cadeau zit nog niet in je winkelmandje. Klik op de knop, dan voegen we het toe en passen we de code automatisch toe.';
          };
          cartHas(res.variantId).then(function (has) {
            showState(has);
            if (has) applyCode(res.code);
          });
          readd.addEventListener('click', function () {
            readd.disabled = true; readd.textContent = 'Even geduld…';
            applyReward(res).then(function (ok) {
              readd.disabled = false; readd.textContent = 'Zet mijn cadeau in het mandje';
              if (ok) { cartNote.textContent = 'Gelukt! We brengen je naar je winkelmandje…'; window.location.href = '/cart'; } else cartNote.textContent = 'Dat lukte niet. Probeer het opnieuw of gebruik de knop in je e-mail.';
            });
          });
        } else {
          panel.appendChild(el('p', 'gh-note', 'De code is automatisch toegepast bij het afrekenen. We mailden hem ook naar je.'));
        }
        var keep = el('button', 'gh-btn gh-btn--ghost', 'Verder winkelen'); keep.type = 'button';
        keep.addEventListener('click', closeModal);
        row.appendChild(keep);
        panel.appendChild(row);
      } else {
        var k = el('button', 'gh-btn', 'Verder winkelen'); k.type = 'button'; k.addEventListener('click', closeModal);
        panel.appendChild(k);
      }
      if (!fromSaved) confetti();
    }

    /* ---------- draaien ---------- */
    function spinTo(res) {
      var jitter = (Math.random() - 0.5) * seg * 0.6;
      var mid = res.index * seg + seg / 2;
      var target = 360 * 6 + (360 - mid) + jitter;
      var finished = false;
      function done() {
        if (finished) return; finished = true;
        lsSet(KEY, JSON.stringify({ code: res.code, label: res.label, type: res.type, expiresAt: res.expiresAt, variantId: res.variantId, inCart: false }));
        applyReward(res).then(function (inCart) {
          var st = saved(); if (st) { st.inCart = inCart; lsSet(KEY, JSON.stringify(st)); res.inCart = inCart; }
          fabLabel();
          showResult(res, false);
        });
      }
      g.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 6800);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        g.style.transform = 'rotate(' + target + 'deg)';
      }); });
    }

    function cartHas(variantId) {
      if (!variantId) return Promise.resolve(false);
      return fetch('/cart.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return (c.items || []).some(function (i) { return String(i.variant_id) === String(variantId); }); })
        .catch(function () { return false; });
    }

    function applyCode(code) {
      if (!code) return Promise.resolve();
      return fetch('/cart/update.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
        .catch(function () {})
        .then(function () { return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); });
    }

    function applyReward(res) {
      var chain = Promise.resolve(false);
      if (res.type === 'free_product' && res.variantId) {
        chain = cartHas(res.variantId).then(function (has) {
          if (has) return true;
          return fetch(CART_ADD, { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(res.variantId), quantity: 1 }] }) })
            .then(function (r) { if (r.ok) cartChanged = true; return r.ok; }).catch(function () { return false; });
        });
      }
      return chain.then(function (inCart) { return applyCode(res.code).then(function () { return inCart; }); });
    }

    function confetti() {
      var colors = COLORS.concat(['#6E4AAE']);
      for (var i = 0; i < 36; i++) {
        var c = el('span', 'gh-confetti');
        c.style.left = (Math.random() * 100) + '%';
        c.style.background = colors[i % colors.length];
        c.style.animationDelay = (Math.random() * 0.5) + 's';
        c.style.animationDuration = (1.8 + Math.random() * 1.6) + 's';
        c.style.setProperty('--dx', ((Math.random() - 0.5) * 160) + 'px');
        box.appendChild(c);
        setTimeout(function (x) { return function () { x.remove(); }; }(c), 4200);
      }
    }

    /* ---------- open / sluit ---------- */
    function openModal() {
      overlay.classList.add('is-open');
      document.documentElement.classList.add('gh-lock');
      var p = saved();
      if (p) { showResult(p, true); } else { showForm(); }
      close.focus();
    }
    function closeModal() {
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('gh-lock');
      lsSet(DISMISS, String(Date.now()));
      if (cartChanged) window.location.reload();
    }
    fab.addEventListener('click', openModal);
    close.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

    var dismissed = Number(lsGet(DISMISS) || 0);
    if (!spun && cfg.delay > 0 && Date.now() - dismissed > 86400000) {
      setTimeout(function () { if (!overlay.classList.contains('is-open')) openModal(); }, cfg.delay * 1000);
    }
  }
})();
